export const SEARCH_TYPE = {
  APP: 'app',
  ORG: 'org',
  CMF: 'cmf',
  SUB: 'sub',
  DMS: 'dms'
};

export const API_TYPE = {
  REST: 'api',
  ASYNC: 'async-api'
};
